export interface FileObject {
  id: number;
  imageId: string;
  name: string;
  fullLink: string;
}
